import { gql, useMutation } from "@apollo/client";
import { useGeneralSoContext } from "src/common/context";
const GENERATE_POLICY_MUTATION = gql(`
  mutation GeneratePolicy($offerId: String!) {
    generatePolicy(id: $offerId)
  }
  `);

export function useGeneratePolicy() {
  const { offerId } = useGeneralSoContext();
  const [mutation, info] = useMutation(GENERATE_POLICY_MUTATION);
  const generatePolicy = async () => {
    if (!offerId) {
      return;
    }
    const { data } = await mutation({
      variables: { offerId },
    });
    return data;
  };
  return [generatePolicy, info] as const;
}
